import { Lumper, CreateLumperDto, UpdateLumperDto, DetentionLumperStatus } from "../types/lumper";
import { unwrapApiResponse } from "../utils/apiUtils";
import { api } from "./apiSlice";

const lumpersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLumpers: builder.query<Lumper[], void>({
      query: () => "lumpers",
      transformResponse: unwrapApiResponse,
      providesTags: ["Lumpers"],
    }),
    getLumperById: builder.query<Lumper, number>({
      query: (id) => `lumpers/${id}`,
      transformResponse: unwrapApiResponse,
      providesTags: (result, error, id) => [{ type: "Lumpers", id }],
    }),
    createLumper: builder.mutation<Lumper, { dto: CreateLumperDto; document?: File }>({
      query: ({ dto, document }) => {
        const formData = new FormData();
        Object.entries(dto).forEach(([key, value]) => {
          if (value === undefined || value === null) return;
          if (typeof value === "boolean") {
            formData.append(key, String(value));
            return;
          }
          if (value === "") return;
          formData.append(key, String(value));
        });
        if (document) formData.append("document", document);
        return { url: "lumpers", method: "POST", body: formData };
      },
      transformResponse: unwrapApiResponse,
      invalidatesTags: ["Lumpers"],
    }),
    updateLumper: builder.mutation<Lumper, { id: number } & UpdateLumperDto>({
      query: ({ id, ...body }) => ({ url: `lumpers/${id}`, method: "PUT", body }),
      transformResponse: unwrapApiResponse,
      invalidatesTags: (_r, _e, { id }) => ["Lumpers", { type: "Lumpers", id }],
    }),
    updateLumperStatus: builder.mutation<Lumper, { id: number; status: DetentionLumperStatus }>({
      query: ({ id, status }) => ({ url: `lumpers/${id}/status`, method: "PATCH", body: { status } }),
      transformResponse: unwrapApiResponse,
      invalidatesTags: (_r, _e, { id }) => ["Lumpers", { type: "Lumpers", id }],
    }),
    deleteLumper: builder.mutation<void, number>({
      query: (id) => ({ url: `lumpers/${id}`, method: "DELETE" }),
      transformResponse: () => undefined,
      invalidatesTags: ["Lumpers"],
    }),
  }),
});

export const {
  useGetLumpersQuery,
  useGetLumperByIdQuery,
  useCreateLumperMutation,
  useUpdateLumperMutation,
  useUpdateLumperStatusMutation,
  useDeleteLumperMutation,
} = lumpersApi;
